//src/pages/Thankyou.js

import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

const ThankYou = () => {
  const navigate = useNavigate();
  return (
    <div className="page-wrapper">
      <Header />
      <div style={{
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        padding: "60px 24px", textAlign: "center", minHeight: "78vh"
      }}>
        <div style={{
          width: 80, height: 80,
          background: "linear-gradient(135deg, #e6f5fb, #edfaf3)",
          borderRadius: "50%",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: "2.4rem", marginBottom: "20px"
        }}>🛡️</div>
        <h2 style={{ fontSize: "1.25rem", fontWeight: 800, marginBottom: "8px" }}>Shukriya!</h2>
        <p style={{ fontSize: "0.85rem", color: "#555", lineHeight: 1.6, marginBottom: "6px" }}>
          Hum par bharosa karne ka shukriya!
        </p>
        <p style={{ fontSize: "0.82rem", color: "#888", lineHeight: 1.6, marginBottom: "32px" }}>
          Hum hamesha aap ki madad ke liye maujood hain.
        </p>
        <button className="btn-blue" onClick={() => navigate("/")} style={{ maxWidth: 220 }}>
          Home Par Jayein
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
